import { LoginForm } from "@/components/login-form";
import { Storage } from "@/services/storage-services";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router";
import Logo from "../../assets/texpress.png";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form, FormField, FormControl, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Eye, EyeClosed, Loader2, Mail } from "lucide-react";
import { HiAnnotation } from "react-icons/hi";
import { AnnotationHeartIcon, AnnotationIcon, BriefcaseIcon, PasscodeIcon, PhoneIcon, PhoneIcon1, PhoneIcon2 } from "@/assets";
import { useMutation } from "@tanstack/react-query";
import { ResendVerificationMail, SignUp, VerifyEmailAddress } from "@/services/Auth.service";
import { ToastMessage, type } from "@/lib/toastr";

export const formSchema = z.object({

  code: z.string().min(6, { message: "Verification code must be 6 characters long" }).max(6, { message: "Verification code can not be more 6 characters long" }),
});

const VerifyEmail = () => {
  const [timer, setTimer] = useState(Number);
  const { state } = useLocation();
  const email = state?.email;
  // const { email } = useParams()
  // const [email, setEmail] = useState('');
  const navigate = useNavigate()
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "all",
    defaultValues: {
      code: ""
    },
  });

  const resendVerification = async () => {
    setTimer(59);
    await ResendVerificationMail({ email })
      .then((res) => {
        // if (res?.data?.statusCode === 200) {
        ToastMessage(type.SUCCESS, "Verification token sent to your email address successfully");
        // }
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 422) {
          ToastMessage(type.ERROR, err?.response?.data?.message);
          setTimer(0)


        } else {

          ToastMessage(type.SUCCESS, "Verification token sent to your email address successfully");
        }

      });
  };
  const mutation = useMutation({
    mutationFn: (data: any) => VerifyEmailAddress(data),
    mutationKey: ['verifyEmail'],

    onSuccess: (res) => {
      // if (res.data.statusCode === 201) {
      navigate('/');
      // navigate(`/VerifyEmail/${email}`);
      // params: { email: email }
      // }
    },
    onError: (err: any) => {
      ToastMessage(type.ERROR, err.response.data.message);


    }
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    mutation.mutate({
      email,
      ...data
    })
  }

  useEffect(() => {
    let counter: ReturnType<typeof setInterval> | undefined;
    if (timer > 0) {
      counter = setInterval(() => setTimer(timer - 1), 1000);
    }
    return () => {
      if (counter !== undefined) {
        clearInterval(counter);
      }
    };
  }, [timer]);


  return (
    <div className="flex flex-col  items-center justify-center gap-6 min-h-svh bg-muted ">
      <div className="flex flex-col items-center gap-6">
        <Link to="/">
          <img src={Logo} className="h-10" />
        </Link>
        <div className={cn("flex flex-col gap-6 ",
          // className
        )}
        // {...props}
        >
          <Card className="w-full lg:w-[542px] p-6">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-medium text-primary">Verify your email address</CardTitle>
              <CardDescription className="">
                We sent a verification code to your email. Please ender the code sent to you
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="grid gap-6">
                  <div className="grid gap-5 w-full">
                    <div className="flex flex-col w-full gap-1">

                      <FormField
                        control={form.control}
                        name="code"
                        render={({ field }) => {
                          return (
                            <FormItem className="space-y-0">
                              <div
                                className={cn(
                                  "w-full  gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-14",
                                  // form.formState.errors?.email === undefined
                                  //   ? "border-input-border"
                                  //   : "border-destructive"
                                )}
                              >
                                {/* <div className="flex flex-col w-full"> */}
                                <FormLabel className="text-xs">Enter verification code</FormLabel>

                                <FormControl>
                                  <Input
                                    className="w-full h-fit px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                    {...field}
                                  // placeholder="Enter Email Address"
                                  />
                                </FormControl>
                                {/* </div> */}
                              </div>
                              <FormMessage />
                            </FormItem>
                          );
                        }}
                      />
                      <Button
                        variant='link'
                        className="text-primary text-sm font-semibold no-underline w-fit hover:no-underline p-0"
                        onClick={resendVerification}
                        disabled={timer > 0}
                      >Didn’t receive code? Resend {timer > 0 ? `in ${timer}` : ''}

                      </Button>
                    </div>

                    <Button
                      type="submit"
                      variant="default"
                      className="w-full bg-gradient-to-r from-primary to-primary-2 h-14 rounded-[10px] p-[10px]  ring-transparent focus-visible:ring-transparent"
                      disabled={
                        !form.formState.isDirty ||
                        !form.formState.isValid ||
                        form.formState.isSubmitting
                      }
                    >
                      {form.formState.isSubmitting && (
                        <Loader2 className="text-white animate-spin" />
                      )}
                      Confirm
                    </Button>
                  </div>
                </form>
              </Form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
